import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpResponse } from '@angular/common/http';

// ** rxjs
import { Observable, of } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';

// ** env
import { environment } from '@env/environment';
import { config } from '@app/core/app.config';

// ** service
import { ErrorCatchService } from './errorCatch.service';

@Injectable({
	providedIn: 'root',
})
export class HomeService {
	constructor(
		private http: HttpClient,
		private router: Router,
		private httpClient: HttpClient,
		private errorCatchService: ErrorCatchService
	) {}

	getContent() {
		const fileName = 'posts.json';
		this.httpClient
			.get(`${config.static}/${fileName}`)
			.pipe(map((res) => res))
			.subscribe(),
			catchError(this.errorCatchService.handler);
	}

	getCooperations(): Observable<any> {
		const fileName = 'cooperation.json';
		return this.httpClient.get(`${config.cooperation}/${fileName}`).pipe(
			map((res) => res),
			catchError(this.errorCatchService.handler)
		);
	}
}
